import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { pushCampaign } from "../actions/dashboard";
import Backdrop from "@material-ui/core/Backdrop";
import Poster from "assets/img/banner.png";
import { withStyles } from "@material-ui/core/styles";

const style = theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff"
  }
});

class Campaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaign: this.props.campaign
    };
  }
  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    console.log(nextProps.campaign, "cammm");
    this.setState({ campaign: nextProps.campaign });
  }

  handleClose = () => {
    this.props.pushCampaign(false);
  };

  render() {
    const { classes } = this.props;
    return (
      <Backdrop
        className={classes.backdrop}
        open={this.state.campaign}
        onClick={this.handleClose}
      >
        <img
          style={{
            height: "80%",
            width: "80%"
            // display: "flex"
          }}
          alt="..."
          src={Poster}
        />
      </Backdrop>
    );
  }
}

Campaign.propTypes = {
  classes: PropTypes.object.isRequired,
  pushCampaign: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    campaign: state.campaign
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    { pushCampaign }
  )(withStyles(style)(Campaign))
);
